import React, { useEffect, useState } from 'react';
import 'assets/styles/variables.css';
import 'assets/styles/LogPage/log-page.css';
import axios from 'axios';
import { useNotificationHandler } from 'hooks/useNotificationHandler';

const Clim4CastLogPage = () => {
    const [lastFTPDate, setLastFTPDate] = useState("Loading...");
    const [lastUpdateDate, setLastUpdateDate] = useState("Loading...");
    const [error, setError] = useState("Loading...");

    const {
        notifyError,
        contextHolder
    } = useNotificationHandler();

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_API_URL}/api/_clim4cast_update_log`)
            .then((value) => {
                const response = value.data;
                setLastFTPDate(response.last_ftp_date);
                setLastUpdateDate(response.last_recorded_date);
                setError(response.error);
            })
            .catch((reason) => {
                notifyError("Server didn't respond or sent an error", "The server's response was unexpected. Reason: " + reason.message);
                setLastFTPDate("-");
                setLastUpdateDate("-");
                setError("-");
            });
    }, []);

    return (
        <div id='log-page'>
            {contextHolder}
            <h1>Clim4Cast error logs</h1>
            <table>
                <thead>
                    <tr>
                        <th>Last date in FTP server</th>
                        <th>Last date with locally updated data</th>
                        <th>Error log</th>
                    </tr>
                </thead>

                <tbody>
                    <tr>
                        <td>{lastFTPDate}</td>
                        <td>{lastUpdateDate}</td>
                        <td dangerouslySetInnerHTML={{__html: error}}/>
                    </tr>
                </tbody>
            </table>
        </div>
    );
}

export default Clim4CastLogPage;